export function startExpiryChecker(expiryTime, onExpired) {
  if (!expiryTime) return null;

  try {
    const normalized = expiryTime.replace(" ", "T").split(".")[0];
    const expiryDate = new Date(normalized);
    if (isNaN(expiryDate.getTime())) throw new Error("Invalid date");

    const checkNow = () => {
      const now = Date.now();
      const expiryMs = expiryDate.getTime();

      if (expiryMs <= now) {
        cleanup();
        onExpired();
        return;
      }

      const msLeft = expiryMs - now;
      if (timerId) clearTimeout(timerId);
      timerId = setTimeout(() => {
        checkNow();
      }, Math.min(msLeft, 30000));
    };

    let timerId = null;

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkNow();
      }
    };

    const onFocus = () => {
      checkNow();
    };

    document.addEventListener("visibilitychange", onVisibilityChange);
    window.addEventListener("focus", onFocus);

    const cleanup = () => {
      if (timerId) clearTimeout(timerId);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("focus", onFocus);
    };

    checkNow();

    return { timerId: () => timerId, cleanup };

  } catch (err) {
    console.error("Expiry checker failed:", err);
    return null;
  }
}

export function clearExpiryChecker(checkerRef) {
  if (!checkerRef) return;
  // Old style (just a timeout ID) backward compatible
  if (typeof checkerRef === "number") {
    clearTimeout(checkerRef);
  } else if (checkerRef?.cleanup) {
    checkerRef.cleanup();
  }
}